import React, { useState, useEffect } from "react";
import { Animate } from "react-move";

const AnimatedProgressProvider = ({
  valueStart = 0,
  valueEnd,
  duration,
  easingFunction,
  repeat,
  children,
}: any) => {
  const [isAnimated, setIsAnimated] = useState(false);

  useEffect(() => {
    let interval: any;
    if (repeat) {
      interval = setInterval(() => {
        setIsAnimated((prevIsAnimated) => !prevIsAnimated);
      }, duration * 1000);
    } else {
      setIsAnimated(true);
    }

    return () => clearInterval(interval);
  }, [duration, repeat]);

  return (
    <Animate
      start={() => ({
        value: valueStart,
      })}
      update={() => ({
        value: [isAnimated ? valueEnd : valueStart],
        timing: {
          duration: duration * 1000,
          ease: easingFunction,
        },
      })}
    >
      {({ value }) => children(value)}
    </Animate>
  );
};

export default AnimatedProgressProvider;
